import CollectQRCode from './CollectQRCode'
import RedeemQRCode from './RedeemQRCode'
import CollectQRCodeLot from './CollectQRCodeLot'
import Activity from './Activity'
import ReportActivity from './ReportActivity'
import ReportCode from './ReportCode'
import ReportCoin from './ReportCoin'
import GivePointM from './GivePointM'
import RefundPoint from './RefundPoint'
import VGroupShortcut from './VGroupShortcut'
import ApiReference from './ApiReference'
import Random from './Random'
import RandomCGS from './RandomCGS'
import MigrationHub from './MigrationHub'
import FuncrowdImport from './FuncrowdImport'

export default {
  CollectQRCode,
  RedeemQRCode,
  CollectQRCodeLot,
  Activity,
  ReportActivity,
  ReportCode,
  ReportCoin,
  GivePointM,
  RefundPoint,
  VGroupShortcut,
  ApiReference,
  Random,
  RandomCGS,
  MigrationHub,
  FuncrowdImport
}



// WEBPACK FOOTER //
// ./src/components/Tool/index.js